import Typography from '@mui/material/Typography';
import { InsertDriveFile } from '@mui/icons-material';
import { useMemo } from 'react';
import { LoadingMask } from '../LoadingMask';
import { Box } from '@mui/material';

interface Props {
  file?: File;
  loading: boolean;
}

export const UploadStep = ({ loading, file }: Props): React.JSX.Element => {
  const fileName = useMemo(() => file?.name ?? '??', [file]);

  const fileSize = useMemo(() => {
    if (file === undefined) {
      return '??';
    }

    const size = Number(file.size / 1024).toFixed(2);

    return size.toString() + ' kB';
  }, [file]);

  return (
    <Box
      component={'div'}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 16,
      }}
    >
      <Box
        component={'div'}
        sx={{
          margin: '0 auto',
          width: '50%',
          padding: 4,
          boxSizing: 'border-box',
        }}
      >
        <Box component={'div'} sx={{ textAlign: 'center' }}>
          {loading && <LoadingMask />}
          <InsertDriveFile
            sx={{
              color: (theme) => theme.palette.primary.main,
              fontSize: '5em',
            }}
          />
          <br />
          <Typography variant={'caption'} style={{ fontSize: '1.1rem' }}>
            {fileName}
          </Typography>
          <br />
          <Typography variant={'caption'} style={{ fontSize: '0.8rem' }}>
            {fileSize}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
